export const getEnv = _ => {
    const development = window.location.href.includes('localhost');
    const staging = window.location.href.includes('admin-staging.matrak.com');
    const sandbox = window.location.href.includes('admin-sandbox.matrak.com');
    const feature = window.location.href.includes('feature.matrak.com');
    const production = window.location.href.includes('https://admin.matrak.com/');
    if(staging) return 'staging'
    if(sandbox) return 'sandbox'
    if(production) return 'prod'
    if(development) return 'local'
    if(feature) return 'feature'
}